import React from 'react';
import { connect } from 'react-redux';
import { Typography } from '@mui/material';
import Collapsible from '../util/Collapsible';
import { SchedulesLoader } from '../loaders/analytics';
import ExecutionsTable from './ExecutionsTable';
import ExecutionDetails from './ExecutionDetails';
import SchedulesTable from './SchedulesTable';
import AnalyticsGraph from './AnalyticsGraph';
import './analytics-qa.css';

class AnalyticsQa extends React.PureComponent {
  state = {
    selected: null,
  };

  getExecId() {
    const { selected } = this.state;
    return selected != null ? selected : this.props.firstExecution;
  }

  render() {
    const onSelect = (id) => this.setState({ selected: id });
    const selected = this.getExecId();
    return (
      <>
        <SchedulesLoader />

        <div className="analytics-qa row grid-container-lg">
          <div className="analytics-graph">
            <AnalyticsGraph />
          </div>
        </div>

        <div className="analytics-qa row grid-container-lg">
          <Typography>Recent executions</Typography>
          <ExecutionsTable selected={selected} onSelect={onSelect} />
          <ExecutionDetails execId={selected} />
        </div>

        <div className="analytics-qa row grid-container-lg">
          <Collapsible headerContent="Schedules">
            <SchedulesTable />
          </Collapsible>
        </div>
      </>
    );
  }
}

export default connect(
  ({
    analytics: {
      executions: { allIds },
    },
  }) => ({
    firstExecution: allIds[0],
  })
)(AnalyticsQa);
